import { render, staticRenderFns } from "./vPreviewLabel.vue?vue&type=template&id=07eaae86&scoped=true"
import script from "./vPreviewLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./vPreviewLabel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eaae86",
  null
  
)

export default component.exports